const Local = window.localStorage

const getLocalItem = (key: string) => {
  try {
    return JSON.parse(Local.getItem(key) as string)
  } catch (err) {
    return null
  }
}
const setLocalItem = (key: string, val: any) => {
  Local.setItem(key, JSON.stringify(val))
}
const clearLocal = () => {
  Local.clear()
}
const LocalKeys = (index: number) => {
  return Local.key(index)
}
const removeLocalItem = (key: string) => {
  Local.removeItem(key)
}
export {
  getLocalItem,
  setLocalItem,
  clearLocal,
  LocalKeys,
  removeLocalItem
}
